import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { IconButton, Stack, Typography } from "@mui/material";

import DeleteOutlineRoundedIcon from '@mui/icons-material/DeleteOutlineRounded';
import EditRoundedIcon from '@mui/icons-material/EditRounded';
import { TableLayout } from '../../layout/TableLayout';
import { selectStartup } from '../../../store/startup/startupSlice';
import { EditStartup } from './';
import { deleteStartup } from '../../helpers';
import { toSpanishDate } from '../../../helpers/dateFormat';


export const StartupTable = ({ rows, setReloadData }) => {

    const { t } = useTranslation('global');
    const [openEdit, setOpenEdit] = useState(false);
    const dispatch = useDispatch();

    const columns = [
        {
            field: 'name',
            headerName: t('startupHeaders.name'),
            minWidth: 200,
            flex: 1,
            align: 'center',
            headerAlign: 'center'
        },
        {
            field: 'alias',
            headerName: t('startupHeaders.alias'),
            minWidth: 170,
            flex: 1,
            align: 'center',
            headerAlign: 'center'
        },
        {
            field: 'country',
            headerName: t('startupHeaders.country'),
            minWidth: 150,
            flex: 1,
            align: 'center',
            headerAlign: 'center'
        },
        {
            field: 'cif',
            headerName: t('startupHeaders.cif'),
            minWidth: 150,
            flex: 1,
            align: 'center',
            headerAlign: 'center'
        },
        {
            field: 'registrationDate',
            headerName: t('startupHeaders.registrationDate'),
            minWidth: 130,
            flex: 1,
            align: 'center',
            headerAlign: 'center',
            renderCell: ({row}) => {
                return <Typography color='primary' variant='body2'>{toSpanishDate(row.registrationDate)}</Typography> 
            }
        },
        {
            field: 'constitutionDate',
            headerName: t('startupHeaders.constitutionDate'),
            minWidth: 150,
            flex: 1,
            align: 'center',
            headerAlign: 'center',
            renderCell: ({row}) => {
                return <Typography color='primary' variant='body2'>{toSpanishDate(row.constitutionDate)}</Typography> 
            }
        },
        {
            field: 'sector',
            headerName: t('startupHeaders.sector'),
            minWidth: 100,
            flex: 1,
            align: 'center',
            headerAlign: 'center'
        },
        {
            field: 'url',
            headerName: t('startupHeaders.url'),
            minWidth: 100,
            flex: 1,
            align: 'center',
            headerAlign: 'center',
            renderCell: (params) => {
                return (<Stack direction='row' gap={0}>
                    <a href={params.row.url} target="_blank" rel="noreferrer">{t('link.link')}</a>
                </Stack>
                )
            }
        },
        {
            field: 'action',
            headerName: t('partnerlist.columnActions'),
            maxWidth: 90,
            align: 'center',
            headerAlign: 'center',
            flex: 0,
            sortable: false,
            renderCell: (params) => {
                return (<Stack direction='row' gap={0}>
                    <IconButton color='secondary' onClick={() => onEditClick(params)}>
                        <EditRoundedIcon />
                    </IconButton>

                    <IconButton color='secondary' onClick={() => onDeleteClick(params)}>
                        <DeleteOutlineRoundedIcon />
                    </IconButton>
                </Stack>
                )
            }
        }
    ];

    const onEditClick = (e) => {
        dispatch(selectStartup(e.row))
        setOpenEdit(true)
    }

    const onDeleteClick = async (e) => {
        await deleteStartup(e, t('delete.successMsg'), t('delete.errorMsg'), t('delete.cancelButton'), t('delete.confirmButton'), t('delete.deleteConfirm'))
        setReloadData(prevState => !prevState)
    }

    return (
        <>
            <TableLayout
                rows={rows}
                columns={columns}
                title='startup'
            />
            {
                openEdit &&
                <EditStartup setHidden={setOpenEdit} setReloadData={setReloadData} />
            }
        </>
    )
}